import { SPONSOR_TYPES_ACTIONS } from './SPONSOR_TYPES_ACTIONS'

export function sponsorTypesReducer(state, action) {
  switch (action.type) {
    case SPONSOR_TYPES_ACTIONS.SET_SPONSOR_TYPES:
      return {
        ...state,
        types: action.payload.types,
      }
    case SPONSOR_TYPES_ACTIONS.SET_IS_LOADING:
      return { ...state, isLoading: action.payload.isLoading }
    default:
      return state
  }
}
